// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"6eb554ef","688":"d2251422","814":"d2251422"}[chunkId] + ".chunk.css";
};